import React, { useState, useEffect, useContext } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import { Icon, notification } from "antd";
import Participante from "./Participante";
import DrawerNotificar from "./Drawers/DrawerNotificar";
import axios from "axios";
import { GlobalContext } from "../../app/providers/GlobalState";
import { GeralContext } from "../ContextProvider";
import ModalGerarDocumento from "../../shared/components/Modals/GerarDocumento";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import Acessos from "../../Geral/Acessos/Acessos";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const Participantes = () => {
    const globalContext = useContext(GlobalContext);
    const [participantes, setParticipantes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visible, setVisible] = useState(false);
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [visibleExport, setVisibleExport] = useState(false);
    const [buttonDownload, setButtonDownload] = useState(false);
    const [exportFile, setExportFile] = useState("");
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [docs, setDocs] = useState([]);

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        listar(localStorage.getItem("codigo_curso"));
    }, [location.pathname]);

    const listar = turmaId => {
        setLoading(true);
        axios
            .get("/api/turma/lista-alunos", {
                params: { turmaId },
                timeout: 600000
            })
            .then(response => {
                setParticipantes(response.data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirect(true);
                    setRedirectLink("/login");
                }
            });
    };

    const montarBotaoVoltar = () => {
        const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
        if (opcaoInfo) {
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso || opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    ←
                </Link>
            );
        }
    };

    const exportarPdf = () => {
        setVisibleLoading(true);
        axios
            .get("/api/aulas-exportar/listagem-alunos-pdf", {
                params: { id: localStorage.getItem("codigo_curso") }
            })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);

                setVisibleLoading(false);
                setVisibleViewer(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleLoading(false);
            });
    };

    const exportarCsv = () => {
        setVisibleExport(true);
        setButtonDownload(true);
        axios
            .get("/api/aulas-exportar/listagem-alunos", {
                params: { id: localStorage.getItem("codigo_curso") }
            })
            .then(response => {
                setButtonDownload(false);
                setExportFile(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleExport(false);
            });
    };

    if (redirect) return history.push(redirectLink);

    return (
        <>
            <Acessos funcionalidadeId={22} />
            <GeralContext.Consumer>
                {geralContext => {
                    return (
                        <div className="container container-body">
                            <Acessos funcionalidadeId={22} />
                            <div className="curso-resultados">
                                <div className="controlos controlos-fundo" style={{ justifyContent: "flex-end" }}>
                                    <div className="bloco-direita">
                                        <Link to="#" className="botao-icon-enviar botao-maior" onClick={() => setVisible(true)}>
                                            <Icon type="mail" />
                                        </Link>
                                        <Link to="#" className="botao-icon-detalhe botao-maior" title="Visualizar" onClick={exportarPdf}>
                                            <Icon type="eye" />
                                        </Link>
                                        <Link to="#" className="botao-icon-download botao-maior" title="Descarregar" onClick={exportarCsv}>
                                            <Icon type="download" />
                                        </Link>
                                        {montarBotaoVoltar()}
                                    </div>
                                </div>
                            </div>
                            <div className="curso-participantes" style={loading ? { display: "block" } : {}}>
                                {loading ? (
                                    <div className="loading-data">
                                        <div className="loading" />
                                    </div>
                                ) : (
                                    participantes.map((participante, index) => (
                                        <Participante
                                            {...participante}
                                            key={index}
                                            dt_fechado={geralContext.dt_fechado}
                                            dt_inicio={geralContext.dt_inicio}
                                            dt_fim={geralContext.dt_fim}
                                            fechado={geralContext.fechado}
                                            responsaveis_entidade={globalContext.responsaveis_entidade}
                                            conf_total_participantes={globalContext.conf_total_participantes}
                                            habilitar_gamificacao={geralContext.habilitar_gamificacao && globalContext.gamificacao_entidade}
                                            perfil="Aluno"
                                        />
                                    ))
                                )}
                            </div>
                            <DrawerNotificar visible={visible} onClose={() => setVisible(false)} total={participantes.length} />
                            <ModalGerarDocumento
                                visibleExportar={visibleExport}
                                ficheiroExportar={exportFile}
                                btnDescarregar={buttonDownload}
                                onClose={() => setVisibleExport(false)}
                            />
                            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />
                        </div>
                    );
                }}
            </GeralContext.Consumer>
        </>
    );
};

export default Participantes;
